import { Stack } from '../../../core/types/stratus';
import createScript from '../../../utils/createScript';

const oneTrustScriptProdUrl =
  'https://www.hp.com/cma/ng/lib/exceptions/privacy-banner.js';
const oneTrustScriptNonProdUrl =
  'https://www.hp.com/cma/ng/lib/exceptions/privacy-banner.js';

export default function injectOneTrust(portalStack: Stack): void {
  const scriptId = 'one-trust-script';
  const oneTrustScript = document.getElementById(scriptId);

  if (!oneTrustScript) {
    const stack = portalStack;
    const nonProdStacks = [Stack.dev, Stack.pie, Stack.stage];

    const scriptUrl = nonProdStacks.includes(stack)
      ? oneTrustScriptNonProdUrl
      : oneTrustScriptProdUrl;

    const script = createScript(scriptId, scriptUrl);

    if (document.head.prepend) {
      document.head.prepend(script);
    } else {
      document.head.appendChild(script);
    }
  }
}
